import React from 'react';
import styles from './mariMessage.module.css';

interface MariPhotoProps {
  src: string;
  alt: string;
}

const MariPhoto: React.FC<MariPhotoProps> = ({ src, alt }) => (
  <div className={styles.photoColumn}>
    <img className={styles.photo} src={src} alt={alt} />
  </div>
);

export default MariPhoto;
